import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { fadeIn } from '../../../../animations/form-error';
import { BaseValidationService } from '../services/base-validation.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { TransactionsService } from '../../../../services/ServiceEntity/transactions.service';
import { AccountService } from '../../../../services/ServiceEntity/account.service';
import { FormService } from '../../../../shared/services/form.service';
import { TCModalService } from '../../../../ui/services/modal/modal.service';
import { CONTENT_BTN_CLASS, POPUP_CONTAINER_CLASS } from '../../../../shared/constant/css-style/css-class.constant';
import {
  SERVICE_ITEM_ID_INFOS_TRANSACTION_RETRAIT_CODE,
  SERVICE_ITEM_ID_INFOS_TRANSACTION_TR_CODE, SERVICE_ITEM_ID_RETRAIT_CODE_CASH, SERVICE_ITEM_ID_TRANSFER_CODE
} from '../../../../shared/constant/service-item.constant';
import { TransactionInfosRetrait } from '../../../../model/transaction/transaction-infos-retrait.model';
import { ICashModel } from '../cash-data-model';

/**
 * Permet d'afficher les informations de la transaction
 * avant d'effectuer un retrait code partiel.
 */
@Component({
  selector: 'app-retrait-code-partiel-infos',
  templateUrl: './retrait-code-partiel-infos.component.html',
  animations: [fadeIn]
})
export class RetraitCodePartielInfosComponent extends BaseValidationService
  implements OnInit, OnDestroy {
  isSaving = false;
  successSave = false;
  serverHasError = false;

  loadingMessagesForm = false;
  theDialogRef: MatDialogRef<RetraitCodePartielInfosComponent>;
  private subs$ = new Subject<void>();

  transactionInfos: TransactionInfosRetrait;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ICashModel,
    private transactionsService: TransactionsService,
    private accountService: AccountService,
    private formService: FormService,
    private dialogRef: MatDialogRef<RetraitCodePartielInfosComponent>,
    protected modal: TCModalService) {
    super(modal);
    console.log('## construct retrait code partiel infos');
    this.theDialogRef = this.dialogRef;
  }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    let p = new FormData();
    p.set('serviceItemId', this.tostring(SERVICE_ITEM_ID_INFOS_TRANSACTION_RETRAIT_CODE));
    p.set('valueCode', this.tostring(this.data.cashDataModel.dataForm.data.get('valueCode')));
    p.set('sentAmount', this.tostring(this.data.cashDataModel.dataForm.data.get('sentAmount')));
    p.set('serviceId', this.tostring(SERVICE_ITEM_ID_RETRAIT_CODE_CASH));
    this.dialogRef.afterClosed().subscribe(res => {
      console.log('## popup closed');
      this.data.cashDataModel.dialogRef.close();
    });
    this.transactionsService.execute(p).subscribe(res => {
      let data = res.body;
      console.log('## success récupération infos transaction: ', data);
      this.transactionInfos = data;
      this.data.cashDataModel.transactionInfosRetrait = data;
    }, err => {
      console.log('## Erreur récupération infos transaction: ', err);
    })
  }

  getInit() {
    if(!this.transactionInfos) {
      return false;
    }
    return true;
  }

  tostring(s: any) {
    return s + '';
  }

  format(n: any) {
    console.log('## type amount: ', typeof (+n));
    return this.formService.format(+n);
  }

  getAmountReceive() {
    const amount: number = +this.data.cashDataModel.dataForm.data.get('sentAmount');
    return this.format((amount - this.transactionInfos?.fees));
  }

  confirm() {
    console.log('## confirm retrait code partiel');
    this.data.cashDataModel.dataForm.loadingMessagesForm = true;
    this.loadingMessagesForm = true;
    const d = this.data.cashDataModel.dataForm;
    this.transactionsService.withdrawalv2(d.data).subscribe((rep) => {
      console.log('### SUCCESS Retrait PARTIAL CASH OUT', rep);
      this.dialogRef.close();
  //    this.cashService.dialogRef.close();
      this.loadingMessagesForm = false;
      this.manageMessageWhenSucceed(rep, d);
      d.reponseTransfert = rep.body;
      this.openModal(d.forModal, 'Resultats du retrait CODE PARTIAL CASH',
        null, { closeButton: true, overlayClose: false }, POPUP_CONTAINER_CLASS);
      d.nextFormData.formulaire.reset();
    }, err => {
      console.log('### ERROR Retrait PARTIAL CASH OUT', err);
      this.loadingMessagesForm = false;
      this.manageMessageWhenError(d);
      // prendre la valeur dans 'myException'.
    });
  }

  getContentClass() {
    return CONTENT_BTN_CLASS;
  }

}